import { gql } from '@apollo/client';

export const orderSavingsQuery = gql`
  query OrderSavings(
    $input: OrderRequestInput!
    $comparisonId: UUID!
    $chosenProductKrn: String!
    $frontEndName: String
  ) {
    orderSavings(
      request: $input
      comparisonId: $comparisonId
      chosenProductKrn: $chosenProductKrn
      frontEndName: $frontEndName
    ) {
        orderId
      }
  }
`;
